<div class="dropdown-container">
  <div [id]="id" class="dropdown-button" [ngStyle]="height && {'height': height}" (click)="openDropdown()" [ngClass]="{'disabled': disabled, 'invalid': invalid}" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <div class="left-container">
      <p class="dropdown-title" *ngIf="selected.length === 0">{{placeholder}}</p>
      <p class="dropdown-title" *ngIf="selected.length === 1">{{selected[0][value]}}</p>
      <p class="dropdown-title" *ngIf="selected.length > 1">{{selected[0][value] + ' +' + (selected.length - 1)}}</p>
    </div>
    <div class="svg-div">
      <img src="../../../../assets/svgs/dropdown_arrow_ico.svg" [ngClass]="{'icon-revert': isOpen && !disabled}" label="arrow-icon" alt="dropdown-arrow">
    </div> 
  </div>
  <ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen">
  <div class="dropdown-box" *ngIf="isOpen && !disabled" [ngClass]="{}">
    <div [id]="id + '-' + option[value]" (click)="selectItem(option)" *ngFor="let option of originalOptions; let i = index" class="item">
      <lib-input-checkbox style="margin-right: 6px;"
      [(ngModel)]="option.selected"></lib-input-checkbox>
      {{option[value]}}
    </div>
  </div>
  </ng-template>
  <div class="backdrop" *ngIf="isOpen && !disabled" (click)="openDropdown()"></div> 
</div>
